module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('md-input-container', {
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("Codigo de Bono")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.bonusCode),
      callback: function($$v) {
        _vm.bonusCode = $$v
      },
      expression: "bonusCode"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }, [_vm._v("Verificar")]), _vm._v(" "), (_vm.search_error.status == 'ERROR') ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.search_error.msg))]) : _vm._e()], 1), _vm._v(" "), (_vm.show_search) ? _c('div', {
    staticStyle: {
      "background": "#f0eded",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h2', [_vm._v("Bono " + _vm._s(_vm.bonus.code))]), _vm._v(" "), (_vm.bonus.used == 0 && _vm.bonus.doctor) ? _c('h4', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("Bono para Prestador: "), _c('b', [_vm._v(_vm._s(_vm.doctorFullName))]), _vm._v(" (RUT: " + _vm._s(_vm.bonus.doctor.code) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_vm._v("Estado de uso del Bono:\n                "), (_vm.bonus.used == 1) ? _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("Utilizado")]) : _vm._e(), _vm._v(" "), (_vm.bonus.used == 0) ? _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Disponible")]) : _vm._e()]), _vm._v(" "), _c('h3', [_vm._v("Estado de pago del Bono:\n                "), (_vm.bonus.paid == 1) ? _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Pagado")]) : _vm._e(), _vm._v(" "), (_vm.bonus.paid == 0) ? _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("No Pagado")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "bonus_info"
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Valor Prestacion")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.bonus.bonus_task.country.currency.prefix) + " " + _vm._s(_vm.formatNumber(_vm.bonus.price, _vm.bonus.bonus_task.country.currency.code)) + " " + _vm._s(_vm.bonus.bonus_task.country.currency.sufix) + " " + _vm._s(_vm.bonus.bonus_task.country.currency.description))])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Descuento COLABORAMED")])]), _vm._v(" "), _c('td', [_vm._v("- " + _vm._s(_vm.bonus.bonus_task.country.currency.prefix) + " " + _vm._s(_vm.formatNumber(_vm.bonus.discount, _vm.bonus.bonus_task.country.currency.code)) + " " + _vm._s(_vm.bonus.bonus_task.country.currency.sufix) + " " + _vm._s(_vm.bonus.bonus_task.country.currency.description))])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Valor a Pagar por Paciente")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.bonus.bonus_task.country.currency.prefix) + " " + _vm._s(_vm.formatNumber(_vm.bonus.final_price, _vm.bonus.bonus_task.country.currency.code)) + " " + _vm._s(_vm.bonus.bonus_task.country.currency.sufix) + " " + _vm._s(_vm.bonus.bonus_task.country.currency.description))])])]), _vm._v(" "), (_vm.bonus.used == 1) ? _c('div', {
    staticClass: "alert alert-info float-spans",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Fecha de Atencion:\n                "), _c('span', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.bonus_date_at) + "\n                ")])]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Prestador:\n                "), _c('span', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.doctorFullName) + " (RUT: " + _vm._s(_vm.bonus.doctor.code) + ")\n                ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_vm._v("Fecha de Emision:")]), _vm._v(" "), _c('span', [_vm._v("\n                " + _vm._s(_vm.bonus_date) + "\n            ")]), _vm._v(" "), _c('h3', [_vm._v("Prestacion:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bonus.bonus_task.name))]), _vm._v(" "), _c('h3', [_vm._v("Codigo Prestacion:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bonus.bonus_task.code))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 float-spans",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Beneficiario:")]), _vm._v(" "), _c('b', [_vm._v("Nombre:")]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.patientFullName))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("RUT: ")]), _c('span', [_vm._v(_vm._s(_vm.bonus.patient.code))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Edad: ")]), _c('span', [_vm._v(_vm._s(_vm.patientAge))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Fecha de Nacimiento: ")]), _c('span', [_vm._v(_vm._s(_vm.bonus.patient.birth_date))]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 float-spans",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Titular:")]), _vm._v(" "), _c('b', [_vm._v("Nombre:")]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.creatorFullName))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("RUT: ")]), _c('span', [_vm._v(_vm._s(_vm.bonus.creator.rut))]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('hr'), _vm._v(" "), (_vm.not_allowed) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                El bono solo se puede utilizar con el Prestador "), _c('b', [_vm._v(_vm._s(_vm.doctorFullName))]), _vm._v(" (RUT:" + _vm._s(_vm.bonus.doctor.code) + ").\n            ")]) : _vm._e(), _vm._v(" "), (_vm.bonus.paid == 0 && _vm.bonus.used == 0 && !_vm.not_allowed) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n            Al presionar el boton \"Utilizar Bono\" usted como Prestador declara haber recibido el pago de "), _c('b', [_vm._v(" " + _vm._s(_vm.bonus.bonus_task.country.currency.prefix) + " " + _vm._s(_vm.formatNumber(_vm.bonus.final_price, _vm.bonus.bonus_task.country.currency.code)) + " " + _vm._s(_vm.bonus.bonus_task.country.currency.sufix) + " " + _vm._s(_vm.bonus.bonus_task.country.currency.description))]), _vm._v(" por parte del Paciente.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.bonus.paid == 1 && _vm.bonus.used == 0 && !_vm.not_allowed) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n            Al presionar el boton \"Utilizar Bono\" usted como Prestador recibira de manera automatica a su cuenta bancaria el valor del bono.\n            ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.bonus.used == 0 && !_vm.not_allowed) ? _c('md-button', {
    staticClass: "md-raised md-warn",
    on: {
      "click": function($event) {
        _vm.use_bonus()
      }
    }
  }, [_vm._v("Utilizar Bono")]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": function($event) {
        _vm.launch_print()
      }
    }
  }, [_vm._v("Imprimir")])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aceed46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/Validate.vue
// module id = 584
// module chunks = 1